import React from "react";

export const DownIcon = () => (
  <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#333333"></path>
  </svg>
);

export const CloseIcon = () => (
  <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M 7.41,6 6,7.42 10.59,12 6,16.58 7.41,18 12,13.42 16.59,18 18,16.58 13.41,12 18,7.42 16.59,6 12,10.58 Z" fill="#333333"></path>
  </svg>
);
